import Vue from "vue";
import VueI18n from "vue-i18n";
import { configure } from "vee-validate";
import cs from "@/lang/cs";
import sk from "@/lang/sk";

Vue.use(VueI18n);
const messages = {
  cs: cs,
  sk: sk
};

const vue18n = new VueI18n({
  locale: "sk",
  messages
});

// validate
configure({
  defaultMessage: (field, values) => {
    values._field_ = vue18n.t(`${field}`);
    return vue18n.t(`validation.messages.${values._rule_}`, values);
  }
});

export default vue18n;
